import { COLORS } from '../../../shared/colors';
import { BarVerticalComponent } from '@swimlane/ngx-charts';
import { StatisticService } from '../../../shared/services/statistic.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
var ActivityComponent = (function () {
    function ActivityComponent(stats, translate) {
        var _this = this;
        this.stats = stats;
        this.translate = translate;
        this.showWeek = true;
        this.currentTab = 0;
        this.data = [
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
        ];
        this.dataWeek = [
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
        ];
        this.dataMonth = [
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
            { name: '', value: 0 },
        ];
        this.week = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
        this.colorScheme = {
            domain: [COLORS.main.primary.rgb],
        };
        // get activity data
        stats.getMyStatistic().then(function (statistics) {
            var todayTimeStamp = moment();
            _this.dataWeek = [];
            for (var day = 0; day < 7; day++) {
                _this.dataWeek.unshift({
                    name: todayTimeStamp.day().toString(),
                    value: statistics[day] || 0,
                });
                todayTimeStamp = todayTimeStamp.subtract(1, 'days');
            }
            _this.data = _this.dataWeek;
            _this.updateChartDimensions();
            todayTimeStamp = moment();
            for (var day = 0; day < 31; day++) {
                if (todayTimeStamp.month() === moment().month() || todayTimeStamp.date() > moment().date()) {
                    _this.dataMonth.unshift({
                        name: todayTimeStamp.date().toString(),
                        value: statistics[day] || 0,
                    });
                    todayTimeStamp = todayTimeStamp.subtract(1, 'days');
                }
            }
            translate.get('GENERAL.daysShort').subscribe(function (res) {
                for (var _i = 0, _a = _this.dataWeek; _i < _a.length; _i++) {
                    var d = _a[_i];
                    d.name = res[d.name];
                }
                if (_this.showWeek) {
                    _this.data = _this.dataWeek;
                }
            });
        });
    }
    ActivityComponent.prototype.ngAfterViewInit = function () {
        this.updateChartDimensions();
    };
    ActivityComponent.prototype.resizeBy = function () {
        var _this = this;
        setTimeout(function () {
            _this.updateChartDimensions();
        }, 300);
    };
    ActivityComponent.prototype.yAxisFormatting = function (value) {
        return value.toString();
    };
    ActivityComponent.prototype.updateChartDimensions = function () {
        if (this.chart && this.chart.dims) {
            this.chart.barPadding = this.chart.dims.width / (this.data.length - 1) - 8;
            this.chart.update();
        }
        else {
            setTimeout(this.updateChartDimensions, 300);
        }
    };
    ActivityComponent.prototype.toggleWeek = function () {
        this.data = this.dataWeek;
        this.showWeek = true;
        this.updateChartDimensions();
    };
    ActivityComponent.prototype.toggleMonth = function () {
        this.data = this.dataMonth;
        this.showWeek = false;
        this.updateChartDimensions();
    };
    return ActivityComponent;
}());
export { ActivityComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/activity/activity.component.ts.pre-build-optimizer.js